import { getIsFieldOwnerPortal } from '../RentalPortalIntegrations'

export function getIsProvenanceOwnershipOfField({ entity, field, ownership }) {
  return ownership.entity === entity && ownership.field === field
}

export function getIsProvenanceFieldPortalOwned(ownership) {
  return !ownership || getIsFieldOwnerPortal(ownership.owner)
}
